import React from "react";
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  ColumnChooser,
  Export,
  Selection,
} from "devextreme-react/data-grid";

const TaxExemptReportTable = ({ reportStore }) => {
  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });
  };

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      <DataGrid
        // id='gridContainer'
        keyExpr='id'
        dataSource={reportStore}
        showBorders={true}
        hoverStateEnabled={true}
        cellHintEnabled={true}
        remoteOperations={false}
        columnAutoWidth
        showRowLines={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
        showColumnLines={true}
        rowAlternationEnabled={true}
        wordWrapEnabled={true}
        onToolbarPreparing={onToolbarPreparing}
        height='auto'
      >
        <HeaderFilter visible={true} />
        <Selection allowSelectAll mode='multiple' selectAllMode='allPages' />

        <Export fileName='tax-exempt-report' enabled allowExportSelectedData />

        <FilterRow visible={true} applyFilter='auto' />

        <Paging defaultPageSize={50} />
        <Pager
          showNavigationButtons={true}
          showPageSizeSelector={true}
          allowedPageSizes={[50, 100, 200]}
          showInfo={true}
        />
        <ColumnChooser enabled={true} mode='select' />
        <Column dataField='id' caption='Customer ID' />
        <Column dataField='groupName' caption='Customer group' />
        <Column dataField='homeStoreName' caption='Home store' />
        <Column dataField='name' caption='Name' />
        <Column dataField='registrationNumber' caption='Customer Number' />
        <Column dataField='email' caption='E-mail' />
        <Column dataField='emailOptOut' caption='Email opt-out' />
        <Column dataField='phone' caption='Phone' />
        <Column dataField='mobile' caption='Mobile' />
        <Column dataField='fax' caption='Entered Date' />
        <Column dataField='webShopUser' caption='Year/Make/Model #1' />
        <Column dataField='ymm2' caption='Year/Make/Model #2' />
        <Column dataField='webpage' caption='Year/Make/Model #3' />
        <Column dataField='rewardPointsDisabled' caption='Reward points' />
        <Column dataField='salesForCashOnly' caption='Sales for cash only' />
        <Column dataField='creditLimit' caption='Credit limit' />
        <Column dataField='paymentDeadline' caption='Payment deadline' />
        <Column dataField='bank' caption='Customer notes at POS' />
        <Column dataField='gln' caption='INTL (I) DOM (D)' />
        <Column dataField='taxExemptNumber' caption='Tax Exemption Number' />
        <Column
          dataField='taxExemptExpirationDate'
          caption='Tax Exemption Expiration Date'
        />
        <Column dataField='taxExemptionType' caption='Tax Exemption Type' />
      </DataGrid>
    </div>
  );
};

export default TaxExemptReportTable;
